<!-- @if (loadingBaseline) {
<div class="bg-surface-50 min-h-screen flex items-start justify-start p-4">
  <div class="bg-white border border-surface-200 rounded-2xl px-5 py-4 shadow-md w-full max-w-md">
    <div class="text-sm font-semibold text-slate-900">Loading T3 baseline data</div>
    <div class="text-xs text-slate-600 mt-2">Please wait...</div>
  </div>
</div>
} @else { -->
<div class="bg-surface-50 flex flex-col gap-6">
    <div class="flex flex-col xl:flex-row gap-4">
        <div class="flex-1 flex flex-col gap-4">
            <app-t3-stats [horizon]="horizon"></app-t3-stats>

            <div
                class="bg-rose-50 border border-rose-100 rounded-2xl px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 shadow-lg">
                <div class="text-xs sm:text-sm text-slate-700">
                    Comparison of base scenario with
                    <span class="font-semibold text-rose-600">{{ selectedInfoSimulation }}</span>
                    for a period of
                    <span class="font-semibold text-rose-600">{{ selectedInfoPeriod }}</span>
                </div>

                <div class="flex items-center gap-2">
                    <select
                        class="bg-white rounded-full px-3 py-1.5 text-xs font-medium text-slate-800 border border-rose-200 focus:outline-none"
                        [(ngModel)]="selectedInfoSimulation" (ngModelChange)="onSimulationChange($event)">
                        @for (r of runs; track r.id) {
                        <option [ngValue]="r.title">{{ r.title }}</option>
                        }
                    </select>

                    <select
                        class="bg-white rounded-full px-3 py-1.5 text-xs font-medium text-slate-800 border border-rose-200 focus:outline-none"
                        [(ngModel)]="selectedInfoPeriod" (ngModelChange)="onPeriodChange($event)">
                        <option [ngValue]="'5 years'">5 years</option>
                        <option [ngValue]="'10 years'">10 years</option>
                        <option [ngValue]="'15 years'">15 years</option>
                        <option [ngValue]="'20 years'">20 years</option>
                    </select>
                </div>
            </div>

            <app-t3-projected-impact [selectedInfoSimulation]="selectedInfoSimulation"
                [selectedInfoPeriod]="selectedInfoPeriod" [selectedCascadeSimulation]="selectedCascadeSimulation">
            </app-t3-projected-impact>

            <div class="dashCostComponent">
                <app-t3-costmetrics [spanYears]="horizon"></app-t3-costmetrics>
            </div>

            <!-- <app-t3-scenarios></app-t3-scenarios> -->
        </div>

        <div class="w-full xl:w-[360px]">
            <app-t3-simulation></app-t3-simulation>
        </div>
    </div>
</div>
<!-- } -->